import api from '../utils/api';

/**
 * @typedef {Object} Template
 * @property {number} id - Brevo Template ID
 * @property {string} name - Template name
 * @property {string} subject - Template subject
 * @property {string} createdAt - Template creation date
 * @property {string} updatedAt - Template last update date
 */

/**
 * @typedef {Object} TemplateDetails
 * @property {number} id - Brevo Template ID
 * @property {string} name - Template name
 * @property {string} subject - Template subject
 * @property {string} htmlContent - Full HTML content
 * @property {boolean} isActive - Template active status
 * @property {string} createdAt - Template creation date
 * @property {string} updatedAt - Template last update date
 */

export const brevoTemplateService = {
  getTemplates: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.status) queryParams.append('status', params.status);
    
    const queryString = queryParams.toString();
    const url = `/api/email-campaigns/brevo-templates${queryString ? `?${queryString}` : ''}`;
    
    const response = await api.get(url);
    return response;
  },

  getTemplateById: async (templateId) => {
    const response = await api.get(`/api/email-campaigns/brevo-templates/${templateId}`);
    return response;
  },
};
